import { render, staticRenderFns } from "./Replies.vue?vue&type=template&id=3e288c9b"
import script from "./Replies.vue?vue&type=script&lang=js"
export * from "./Replies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e288c9b')) {
      api.createRecord('3e288c9b', component.options)
    } else {
      api.reload('3e288c9b', component.options)
    }
    module.hot.accept("./Replies.vue?vue&type=template&id=3e288c9b", function () {
      api.rerender('3e288c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Replies.vue"
export default component.exports